import { render, staticRenderFns } from "./UserRetireDialog.vue?vue&type=template&id=21f89baa"
import script from "./UserRetireDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRetireDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports